import { SERVER_BASE_URL } from 'infra/constant'
import { filterError } from 'api/error'
import { ResponseEnvelope } from 'infra/type'

const chainErrorFilter = (res: Response) => filterError(res)
const chainJsonParser = (res: Response) => res.json()

class TokenManager {
  _token: string | null = null

  setToken(token: string | null) {
    this._token = token
  }

  get authHeader(): object {
    return this._token ? { Authorization: `Bearer ${this._token}` } : {}
  }
}
export const tokenManager = new TokenManager()

export const getRequest = async <T = unknown>(
  path: string,
): Promise<ResponseEnvelope<T>> => {
  return fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'GET',
    headers: { ...tokenManager.authHeader },
  })
    .then(chainErrorFilter)
    .then(chainJsonParser)
}

export const postRequest = async (
  path: string,
  payload?: object,
): Promise<ResponseEnvelope> => {
  return fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...tokenManager.authHeader },
    body: JSON.stringify(payload),
  })
    .then(chainErrorFilter)
    .then(chainJsonParser)
}

export const postFormRequest = async (
  path: string,
  body: FormData,
): Promise<ResponseEnvelope> => {
  return fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'POST',
    // Do not set multipart Content-Type manually. Native fetch must generate
    // the boundary matching this FormData body (especially on iOS).
    headers: { ...tokenManager.authHeader },
    body,
  })
    .then(chainErrorFilter)
    .then(chainJsonParser)
}

export const putFormRequest = async (
  path: string,
  body: FormData,
): Promise<ResponseEnvelope> => {
  return fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'PUT',
    headers: { ...tokenManager.authHeader },
    body,
  })
    .then(chainErrorFilter)
    .then(chainJsonParser)
}

export const putRequest = async (
  path: string,
  payload: object,
): Promise<ResponseEnvelope> => {
  return fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...tokenManager.authHeader },
    body: JSON.stringify(payload),
  })
    .then(chainErrorFilter)
    .then(chainJsonParser)
}

export const deleteRequest = async (
  path: string,
  payload?: object,
): Promise<ResponseEnvelope> => {
  return fetch(`${SERVER_BASE_URL}${path}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...tokenManager.authHeader },
    body: JSON.stringify(payload),
  })
    .then(chainErrorFilter)
    .then(chainJsonParser)
}
